import React, { useState } from "react";
import PeopleListInput from "../PeopleListInput/PeoplelList";
import "./hero.css";
import { Card } from "react-bootstrap";
import RandomPeoplePicker from "../RandomPeoplePicker/RandomPeoplePicker";
import TeamGenerator from "../TeamGenerator/TeamGenerator";

const Hero = () => {
  const [peopleList, setPeopleList] = useState([]);

  return (
    <div className="hero">
      <div className="hero-title">
        <h1>Random Team Generator</h1>
        <h5>A random team generator that helps to produce random groups.</h5>
      </div>

      <Card className="hero-card p-4">
        <Card.Body className="cardd-body">
          <Card.Title className="text-left">Add your participants</Card.Title>
          <div className="participants-input">
            <div className="input-container">
              <PeopleListInput onChange={setPeopleList} />
            </div>
            <div className="generator-container">
              <TeamGenerator list={peopleList} />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Hero;
